import {Levels} from "@/api/error";

export interface SnackbarState {
    message: string | undefined,
    level: Levels
}

export default {
    namespaced: true,
    state: {
        message: undefined,
        level: Levels.INFO
    } as SnackbarState,
    getters: {
    },
    mutations: {
        SET_MESSAGE(state:SnackbarState, message:string) {
            state.message = message
        },
        SET_LEVEL(state:SnackbarState, level:Levels) {
            state.level = level
        }
    },
    actions: {
        showMessage(context: any, message: SnackbarState) {
            context.commit('SET_LEVEL', message.level ? message.level : Levels.INFO)
            context.commit('SET_MESSAGE', message.message)
        }
    }
}